import { NavLink } from 'react-router-dom';

// Mobile-only nav. Five fixed tabs so it's reachable with a thumb.
// /more is a routing surface for admin + profile + sign-out on phones.
const TABS = [
  { to: '/clock',     label: 'Clock', icon: 'ph-timer' },
  { to: '/timesheet', label: 'Time',  icon: 'ph-table' },
  { to: '/documents', label: 'Docs',  icon: 'ph-file-text' },
  { to: '/pay',       label: 'Pay',   icon: 'ph-receipt' },
  { to: '/more',      label: 'More',  icon: 'ph-dots-three-circle' },
];

export default function BottomTabBar() {
  return (
    <nav className="tabbar" aria-label="Primary">
      {TABS.map(t => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) => 'tabbar-item' + (isActive ? ' active' : '')}
        >
          <i className={'ph ' + t.icon} />
          <span>{t.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
